"use client";

import { useEffect } from "react";
import { createClient } from "@/lib/supabase/client";

/**
 * Detects Supabase implicit flow recovery tokens in the URL hash.
 * @supabase/ssr uses PKCE flowType which ignores hash fragments,
 * so we manually parse them and redirect to /reset-password.
 */
export function RecoveryHashHandler() {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash || !hash.includes("access_token")) return;

    const params = new URLSearchParams(hash.substring(1));
    const accessToken = params.get("access_token");
    const refreshToken = params.get("refresh_token");
    const type = params.get("type");

    if (accessToken && refreshToken && type === "recovery") {
      const supabase = createClient();
      supabase.auth
        .setSession({ access_token: accessToken, refresh_token: refreshToken })
        .then(({ error }) => {
          if (!error) {
            window.location.href = "/reset-password";
          }
        });
    }
  }, []);

  return null;
}
